<template>
  <div>
    投注站购买实战超市方案
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>